import { render, staticRenderFns } from "./custom-select.vue?vue&type=template&id=635942c6&scoped=true"
import script from "./custom-select.vue?vue&type=script&lang=js"
export * from "./custom-select.vue?vue&type=script&lang=js"
import style0 from "./custom-select.vue?vue&type=style&index=0&id=635942c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635942c6",
  null
  
)

export default component.exports